







import { Component, Vue } from 'vue-property-decorator';
import EditLov from '@/components/EditLov.vue'; // @ is an alias to /src

@Component({
  components: {
    EditLov,
  },
})
export default class Lov extends Vue {}
